export default __webpack_public_path__ + "images/0c503de99fd36a8cd0bf21f5c5f71cf6.png";